<template>
  <div class="main">
    <div v-if="step==='groupConfig'" class="groupConfig">
      <module-title title="分组配置">
        <div class="right">
          <el-button
            type="primary"
            size="medium"
            @click="handleGroupConfig"
          >
            添加分组
          </el-button>
          <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="$emit('back')">
            返回
          </el-button>
        </div>
      </module-title>
      <div class="groupConfig-main">
        <div>
          <el-form ref="searchForm" :model="searchForm" :inline="true" label-position="right" label-width="100px" :rules="searchRules">
            <el-form-item label="组名：" prop="name">
              <el-input
                v-model="searchForm.name"
                name="name"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                size="medium"
                icon="el-icon-search"
                @click="handleSearchFilter"
              >
                查询
              </el-button>
            </el-form-item>
          </el-form>
          <el-table
            v-loading="listLoading"
            :data="applicationList"
            highlight-current-row
            fit
            element-loading-text="Loading"
            class="list-table"
          >
            <el-table-column type="index" width="55" align="center" label="序号" />
            <el-table-column label="组名" prop="name" align="center" />
            <el-table-column label="分组学校" prop="school" align="center">
              <template slot-scope="scope">
                <span :title="(scope.row.schools && scope.row.schools.map(item=>item.name).join(','))">{{ (scope.row.schools && scope.row.schools.map(item=>item.name).join(','))|substring(20) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="updateDate" width="150px" />
            <el-table-column label="操作" align="center" width="300px">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-edit"
                  @click="handleGroupConfig(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  type="danger"
                  size="small"
                  @click="deleteApplication(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :total="searchForm.total"
            :page.sync="searchForm.pageNum"
            :limit.sync="searchForm.pageSize"
            @pagination="pageCurriculumList"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <upgrade-group-school v-else :id="currentGroupId" :campus-app-id="campusAppId" :type-code="typeCode" @back="back" />
  </div>
</template>

<script>
import UpgradeGroupSchool from './upgradeGroupSchool.vue';
import { campusAppGroups, campusDeleteGroups } from '@/api/systemManage/softwareUpdate';

export default {
  name: 'GroupConfig',
  components: {
    UpgradeGroupSchool
  },
  props: {
    campusAppId: {
      type: String,
      default: ''
    },
    typeCode: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      listLoading: false,
      searchForm: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        name: ''
      },
      applicationList: [],
      searchRules: { name: [{ max: 50, message: '请输入50以内的字符', trigger: 'blur' }] },
      step: 'groupConfig',
      currentGroupId: ''
    };
  },
  mounted() {
    this.fetchApplicationList();
  },
  methods: {
    // 条件查询
    handleSearchFilter() {
      this.$refs['searchForm'].validate((valid) => {
        this.searchForm.pageNum = 1;
        this.searchForm.pageSize = 10;
        this.fetchApplicationList();
      });
    },
    // 获取列表数据
    fetchApplicationList() {
      this.searchForm = { ...this.searchForm, ...{ campusAppId: this.campusAppId, typeCode: this.typeCode }};
      this.listLoading = true;
      campusAppGroups(this.searchForm)
        .then((result) => {
          this.applicationList = result.data.list;
          this.searchForm.total = result.data.total;
          this.listLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.listLoading = false;
          this.applicationList = [];
          this.searchForm.total = 0;
        });
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchApplicationList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchApplicationList();
    },
    handleGroupConfig(row) {
      this.step = 'upgradeGroupSchool';
      this.currentGroupId = row ? row.id : '';
    },
    // 删除应用
    deleteApplication(row) {
      this.$confirm(`您确定删除该组吗？`, '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        campusDeleteGroups({ ids: [row.id] + '' }).then((res) => {
          this.$notify.success({
            title: 'Success',
            message: '删除成功',
            showClose: false,
            duration: 2000
          });
          this.fetchApplicationList();
        })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    back() {
      this.step = 'groupConfig';
      this.fetchApplicationList();
    }
  }
};
</script>
